<button
  (click)="qualifiedStaffChanged()"
  nzBlock
  nz-button
  nzType="default"
  style="margin-left: 0.5rem"
  [disabled]="disabled"
  type="button"
  class="fw-normal w-100"
>
  {{
    'page.shift_timeline.find_staff_modal.show_more.qualifications' | translate
  }}
</button>
